<template>
  <div :class="$style.auth">
    <div class="pt-5 pb-5 d-flex align-items-end mt-auto login-logo-box">
      <div class="main-logo">
        <img src="resources/images/truelife-logo.png" alt="Truelife" />
        <div class="air__utils__logo__text">
          <div class="air__utils__logo__name text-uppercase text-dark font-size-21">Truelife</div>
          <div class="air__utils__logo__descr text-uppercase font-size-12 text-gray-6">Account Dashboard</div>
        </div>
      </div>
      <div class="challenge-logo">
        <img src="https://lirp.cdn-website.com/6bb667a1/dms3rep/multi/opt/logo+sharethetruthNOWlogo+copy-1920w.png" alt="Truelife" />
      </div>
    </div>
    <div class="pl-5 pr-5 pt-5 pb-5 bg-white text-center" :class="$style.container">
      <div class="text-dark font-size-30 mb-2 text-center">Sign In</div>
      <div class="mb-4">
        <a-result v-if="errorMessage && errorMessage.reason === 'account_paused'" status="warning" title="Your account is paused." sub-title="Please call 1-800-749-0570 to access your account.">
          <template #extra>
            <a-button type="primary" size="large" class="text-center btn btn-success w-100 font-weight-bold font-size-18" @click="errorMessage = null"> Ok </a-button>
          </template>
        </a-result>
        <a-form class="mb-4" :form="form" @submit="handleSubmit" v-else>
          <a-form-item>
            <a-input size="large" placeholder="Email" v-decorator="['email', { initialValue: '', rules: [{ required: true, message: 'Please input your email!' }] }]" />
          </a-form-item>
          <a-form-item>
            <a-input size="large" placeholder="Password" type="password" v-decorator="['password', { initialValue: '', rules: [{ required: true, message: 'Please input your Password!' }] }]" />
          </a-form-item>
          <a-button type="primary" htmlType="submit" size="large" class="text-center btn btn-success w-100 font-weight-bold font-size-18">Log in</a-button>
        </a-form>
      </div>
      <router-link to="/users/forgot-password" class="text-blue font-weight-bold font-size-18">Forgot password?</router-link>
    </div>
    <!-- <p class="mt-3">"We have recently made updates to our website. Please reset your password using the email you signed up with"</p> -->
    <div class="text-center font-size-18 pt-4 mb-auto">
      Don't have an account?
      <a :href="appURL + '/jesusstorychallenge'" class="font-weight-bold text-blue" style="padding-left: 2px; padding-right: 16px">
        <u style="text-decoration: none">Sign Up</u>
      </a>
      Need Help?
      <a :href="appURL + '/pages/contact-truelife-org'" class="font-weight-bold text-blue text-underlined" style="padding-left: 2px">Contact Support</a>
    </div>
    <div class="mt-auto pb-5 pt-5">
      <ul class="list-unstyled d-flex mb-2 flex-wrap justify-content-center" :class="$style.footerNav">
        <li>
          <a href="https://www.truelife.org/pages/terms-of-use">Terms of Use</a>
        </li>
        <li>
          <a href="https://www.truelife.org/pages/contact-truelife-org">Support</a>
        </li>
        <li>
          <a href="https://www.truelife.org/pages/contact-truelife-org">Contact</a>
        </li>
      </ul>
      <div class="text-gray-4 text-center">© {{ thisYear }} truelife. All rights reserved.</div>
    </div>
  </div>
</template>
<script>
import AuthService from '@/services/AuthService';
import UserService from '@/services/UserService';
import jwtDecode from 'jwt-decode';
import { mapGetters, mapState } from 'vuex';
import moment from 'moment';
import Constants from '@/constants.js';
import { includes } from 'lodash';

export default {
  name: 'AirLogin',
  data: function () {
    return {
      form: this.$form.createForm(this),
      errorMessage: {},
    };
  },
  computed: {
    ...mapGetters(['user']),
    ...mapState({
      billingInfo: state => state.payment.billingInfo,
    }),
    thisYear() {
      return moment().format('YYYY');
    },
    appURL() {
      return Constants.APP_URL;
    },
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          // TODO: DELETE AFTER AUTHENTICATION TESTING IS DONE
          this.$nprogress.start();
          // let user = {
          //   email: values.email,
          //   password: values.password
          // };
          // this.$store.commit('UPDATE_USER', { user })
          // this.$router.push('/')
          // this.$notification['success']({
          //   message: 'Logged In',
          //   description: 'You have successfully logged in to Truelife Dashboard!',
          // })
          // this.$nprogress.done()
          // TODO: PUT BACK THIS SNIPPET AFTER AUTHENTICATION TESTING IS DONE
          // this.$nprogress.start()
          let user = {
            email: values.email,
            password: values.password,
          };
          try {
            const response = await AuthService.login(user.email, user.password);
            const userInfo = jwtDecode(response.jwt);
            this.$store.dispatch('updateUser', {
              user: {
                ...userInfo,
                jwt: response.jwt,
              },
            });

            // Redirect to SHARE YOUR JESUS STORY PAGE for the first login INDIVIDUALS
            // if (includes(userInfo.role, 'individual') && userInfo.is_first_login) {
            //   await UserService.doUpdateUser({
            //     email: userInfo.email,
            //     is_first_login: false,
            //   });

            //   window.location.replace(`${Constants.APP_URL}/share-story?from=${window.location.origin}&sharedSession=${response.jwt}`);
            //   return false;
            // }

            this.$notification['success']({
              message: 'Logged In',
              description: 'You have successfully logged in to Truelife Dashboard!',
            });
          } catch (error) {
            const errorData = error.response.data;
            if (errorData.reason === 'account_paused') {
              this.errorMessage = errorData;
            } else {
              this.$notification['warning']({
                message: 'Login Failed',
                description: 'Password invalid or expired',
              });
            }

            return;
          } finally {
            this.$nprogress.done();
          }

          const userInfos = await UserService.doGetUserInfo1();
          await this.$store.dispatch('updateUser', {
            user: {
              ...this.user,
              accountId: userInfos.account_id,
              accountSlug: userInfos.account_slug,
              userId: userInfos.id,
              restricted: userInfos.restricted || userInfos.state !== 'active',
              churchName: userInfos.church_name,
              churchWebsite: userInfos.church_website,
              waitingVideos: userInfos.waiting_videos,
              newConnections: userInfos.new_connections,
              churchPhone: userInfos.church_phone,
              churchStatus: userInfos.church_status,
              intro_video_slug: userInfos.intro_video_slug,
              membership: userInfos.membership,
              inviteVideo: userInfos.invite_video,
              inviteChurchLogo: userInfos.invite_church_logo,
              shippingInfo: userInfos.shipping_address,
              story: userInfos.story,
              profileVideo: userInfos.profile_video,
            },
          });
          if (this.isAdmin) {
            this.$router.push({ name: 'AdminDashboard' });
          } else {
            // Accept church invitation
            const { church } = this.$router.currentRoute.query;

            if (this.isIndividual && church) {
              await UserService.doAcceptChurchInvitation({
                email: this.$store.state.user.user.email,
                church,
              });
            }

            await this.$store.dispatch('fetchBillingInfo');

            if (this.isIndividual) {
              if (userInfos.moderator && userInfos.moderator.status === 'invited') {
                this.$router.push({ name: 'becomeModerator' });
              } else {
                if (userInfos.story) {
                  this.$router.push({ name: 'individualDashboard' });
                } else {
                  this.$router.push({ name: 'shareYourStory' });
                  // this.$router.push({ name: 'captureVideo', query: { redirectTo: 'shareYourStory' } });
                }
              }
            } else if (includes(userInfos.role, 'free_evangelism')) {
              this.$router.push({ name: this.isPastor ? 'dashboard' : 'careDashboard' });
            } else {
              const membership = this.$store.state.user.user.membership;
              // https://developers.recurly.com/api-v2/v2.29/#tag/subscriptions
              if (!this.billingInfo || !membership || !['active', 'live'].includes(membership.state) || userInfos.restricted) {
                this.$router.push({ name: 'paymentInfo' });
              } else {
                this.$router.push({ name: this.isPastor ? 'dashboard' : 'careDashboard' });
              }
            }
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" module>
@import '@/components/Auth/style.module.scss';

.updatestatement {
  padding: 40px;
}
</style>
<style lang="scss">
.ant-result .ant-result-subtitle {
  font-size: 20px !important;
  color: rgba(0, 0, 0, 0.65) !important;
}
.login-logo-box {
  display: flex;
  justify-content: space-between;
  max-width: 540px;
  width: 100%;
  .main-logo {
    display: flex;
    width: 180px;
  }
  .challenge-logo {
    img {
      width: 140px;
      margin-bottom: -30px;
    }
  }
}
</style>
